import React from 'react';
import { Form } from 'react-bootstrap';

import * as styles from './Diy.module.css';

const GroupActionButton = ({ formData, handleInputChange }) => {
  return (
    <>
      <Form.Group
        className={styles.persona}
        controlId="ActionButtonlabel1"
        key="ActionButtonlabel1"
      >
        <Form.Label className={styles.diyLabel}>Personalization</Form.Label>
        <Form.Control
          name="ActionButtonlabel1"
          type="text"
          className={styles?.name}
          placeholder="Label 1"
          value={formData?.ActionButtonlabel1}
          onChange={handleInputChange}
          autoComplete="off"
        />
      </Form.Group>
      <Form.Group
        className={styles.persona}
        controlId="ActionButtonlabel2"
        key="ActionButtonlabel2"
      >
        <Form.Control
          name="ActionButtonlabel2"
          type="text"
          className={styles?.name}
          placeholder="Label 2"
          value={formData?.ActionButtonlabel2}
          onChange={handleInputChange}
          autoComplete="off"
        />
      </Form.Group>
      <Form.Group
        className={styles.persona}
        controlId="ActionButtonlabel3"
        key="ActionButtonlabel3"
      >
        <Form.Control
          name="ActionButtonlabel3"
          type="text"
          className={styles?.name}
          placeholder="Label 3"
          value={formData?.ActionButtonlabel3}
          onChange={handleInputChange}
          autoComplete="off"
        />
      </Form.Group>
    </>
  );
};

export default GroupActionButton;
